import { FormControl } from '@angular/forms';
import { ApplianceDetailsModelSerialFormField } from './appliance-details-model-serial-form-field.enum';

export interface ApplianceDetailsModelSerialForm {
  [ApplianceDetailsModelSerialFormField.ModelNumber]: FormControl<
    string | null
  >;
  [ApplianceDetailsModelSerialFormField.SerialNumber]: FormControl<
    string | null
  >;
}
